import Axios from 'axios';
import { protectedResources } from '../authConfig';

const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/GetAdvanceSalaryRequestChart';
let tokenKey;

export async function getChartAmount(year) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    year: year,
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
    console.error(error);
  }
}
